module.exports = __webpack_public_path__ + "static/mangochango_logo-9cd988785f4f2421992543f04280495e.png";